import { createTRPCClient, httpLink } from "@trpc/client"
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server"
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query"
import superjson from "superjson"

import { queryClient } from "@/services/queryClient"

import type { AppRouter } from "../../../backend/src/routers/trpc/appRouter"

export type RouterInput = inferRouterInputs<AppRouter>
export type RouterOutput = inferRouterOutputs<AppRouter>

// Session id is the first path segment (/$sessionId/...), the same convention backgroundUploader uses.
function sessionIdHeaders(): Record<string, string> {
  const [, firstSegment] = window.location.pathname.split("/")

  if (firstSegment === undefined || firstSegment === "" || firstSegment === "demo") {
    return {}
  }

  return { "X-Session-Id": firstSegment }
}

// httpLink (not httpBatchLink): batching joined procedure names into one GET URL and overflowed Fastify's path
// limit (404 -> broke the whole batch) — unbatched requests stay short and isolate per-query failures
export const trpc = createTRPCClient<AppRouter>({
  links: [httpLink({ url: "/api/trpc", transformer: superjson, headers: sessionIdHeaders })],
})

// Singleton proxy works outside React too (route loaders, backgroundUploader)
export const trpcOptions = createTRPCOptionsProxy<AppRouter>({ client: trpc, queryClient })
